import React, { useState, useLayoutEffect } from 'react'
// import { graphql } from 'gatsby'

import '../styles/global.scss'
import Seo from '../components/seo'
import Nav from '../components/nav'
import Landing from '../components/landing'
import Section from '../components/section'
import Projects from '../components/projects'
import DevStack from '../components/devstack'
import About from '../components/about'
import Footer from '../components/footer'
// import ArticlesComponent from '../components/articles'

/**
 * 
 * A few things to know:
 * - This app use React Responsive because I wasn't aware that
 * this package doesn't support SSR pretty well. Found out very
 * late in production and just patched-it up.
 * 
 * - As in SSR things are preprocessed, the app doesn't know 
 * the width and height prior to being rendered.
 * Thus, react-responsive cannot select the right mediaQueries.
 * 
 * - After few researches, I found two issues opened on the
 * react-responsive github:
 * # https://github.com/contra/react-responsive/issues/257#issuecomment-677619268
 * # https://github.com/contra/react-responsive/issues/162#issuecomment-592082035
 * 
 * - The first solution forces a double render,
 * first with a forced Context (width: 1408), then with no context at all.
 * 
 * - The second is a custom hook to 
 * selectively rehydrate all components which use react-responive. 
 * The idea is to map all breakpoints into the hook in order to return an object
 * containing all the double refreshed bool from react-responsive.
 * 
 */

export default ({ data }) => {

  const [isLoaded, setIsLoaded] = useState(false)

  useLayoutEffect(() => {
    window.onbeforeunload = () => {
      window.scrollTo(0, 0)
    }
  }, []);

  const app = (
    <div id="app">
      <noscript>
        <style dangerouslySetInnerHTML={{__html: `
          .loader__wrapper {
            display: none;
          }
        `}} />
        <p>JavaScript est requis pour voir ce site, désolé :(</p>
      </noscript>

      <Seo />
      <Nav isLoaded={isLoaded} />
      <Landing setIsLoaded={setIsLoaded} />
      <Section className="projects-wrapper" id="projects-anchor">
        <Projects />
      </Section>
      <Section className="devstack-wrapper">
        <DevStack />
      </Section>
      <Section id="about-anchor">
        <About />
      </Section>
      <Footer />
    </div> 
  )

  return app
}

// Page query
// export const data = graphql`
//   query {
//     allStrapiArticle {
//       edges {
//         node {
//           strapiId
//           title
//           category {
//             name
//           }
//           image {
//             publicURL
//           }
//         }
//       }
//     }
//   }
// `
